export type ApplicationModuleId = number;

export function applicationModuleId(input: number): ApplicationModuleId {
    return input as ApplicationModuleId;
}

export enum ApplicationModuleCode {
    INTENSIVE_TIMESERIES = 'intensive_timeseries',
    EXTENSIVE_TIMESERIES = 'extensive_timeseries',
    DATABOARDS = 'databoards',
    DEPRECATED_DEET = 'deprecated_deet',
    IOT_SUPERVISION = 'iot_supervision',
    IPMVP_VISION = 'ipmvp_vision',
    IPMVP_EDITION = 'ipmvp_edition',
    COMPRESSED_AIR_BI_MEASURES = 'compressed_air_bi_measures',
    HIDE_TO_GERMAN = 'hide_to_german',
    HIDE_TO_ITALY = 'hide_to_italy',
    PREMIUM_RECOMMENDED_ACTIONS = 'premium_recommended_actions',
    MIP = 'mip',
    MIP_PREMIUM = 'mip_premium',
    TUTORIAL_DISABLED = 'tutorial_disabled'
}

export function applicationModuleCode(input: string): ApplicationModuleCode {
    return input as ApplicationModuleCode;
}

export interface ApplicationModule {
    applicationModuleId: ApplicationModuleId;
    isOpenToPublic: boolean;
    isOpenToInternal: boolean;
    code: ApplicationModuleCode;
    type: string;
}
